module.exports = __webpack_public_path__ + "img/ic-step-divider.572911ba.svg";